import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import isAcceptanceTest from 'forms-utils-lib/localStorage/isAcceptanceTest';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { getFormTypeRoute, getTemplatesRoute } from 'FormsUI/lib/RouteGenerators';
import { useHistory } from 'react-router-dom';
import { isUngatedForLimitedAccessLegacyForms } from 'FormsUI/selectors/Gates';
export const useFormCreation = ({
  isPortalZeroState
}) => {
  const ungatedForLimitedAccessLegacyForms = useSelector(isUngatedForLimitedAccessLegacyForms);
  const history = useHistory();
  const pushRoute = useCallback(route => history.push(route), [history]);
  const pushRedirect = useCallback((redirectPush, route) => redirectPush(route), []);
  const withTracking = fn => (isZeroState, ...args) => {
    if (!isAcceptanceTest()) {
      trackDashboardInteraction('create-new-form', {
        state: isZeroState ? 'zero-state' : 'has-forms'
      });
    }
    fn(...args);
  };
  const onCreateFormClick = useCallback(() => {
    const pushRedirectWithTracking = withTracking(pushRedirect);
    const route = ungatedForLimitedAccessLegacyForms ? getTemplatesRoute() : getFormTypeRoute();
    pushRedirectWithTracking(isPortalZeroState, pushRoute, route);
  }, [isPortalZeroState, pushRedirect, pushRoute, ungatedForLimitedAccessLegacyForms]);
  return {
    onCreateFormClick
  };
};